import React, { useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import DataViewerFrame from "../../widgets/DataViewerFrame";
import MethodChooser from "../../choosers/MethodChooser";
import UsersBySectorTable from "./UsersBySectorTable";

const UsersBySectorTableWidget = props => {
  const [methodId, setMethodId] = useState();

  return (
    <DataViewerFrame
      reference="Table 2.1"
      title="Users by Sector, 2018"
      subtitle="Segmented by GNI Group"
      filters={[
        <MethodChooser
          id="table-2-1"
          methods={props.database.methods}
          selectedKey={methodId}
          onChange={methodId => {
            setMethodId(methodId);

            props.onChange({
              widget: "theme2.usersBySectorTable",
              payload: {
                methodId
              }
            });
          }}
        />
      ]}
      onDownloadCsv={() =>
        props.onDownloadCsv({
          method: methodId ? props.database.methods[methodId] : "All"
        })
      }
    >
      <UsersBySectorTable data={props.data} />
    </DataViewerFrame>
  );
};

UsersBySectorTableWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  onDownloadCsv: PropTypes.func.isRequired
};

export default UsersBySectorTableWidget;
